import api from '../../services/api';

export const upsellingApi = {
  /** Requests other admins sent to me. Paginated, always PENDING. */
  getIncomingUpsells: async (params) => {
    const { data } = await api.get('upsellings/partnerships/incoming/', { params });
    return data;
  },

  /** Accept or reject requests. Takes ORDER ids, and only the receiver may call it. */
  manageUpsellRequests: async (payload) => {
    const { data } = await api.post('upsellings/partnerships/manage_requests/', payload);
    return data;
  },

  /** Cede orders to a partner. Takes ORDER ids; answers with DELIVERY ids. */
  assignDeliveries: async (payload) => {
    const { data } = await api.post('upsellings/partnerships/assign/', payload);
    return data;
  },
};
